const validationRules = {
  required: {
    validate: function (val) {
      const valid = Boolean(val);
      const msg = valid ? "" : "This field is required.";
      return { valid: valid, msg: msg };
    },
  },
  numbersOnly: {
    validate: function (val) {
      if (val === null) {
        val = "";
      }
      const regex = /^[0-9]+$/;
      const valid = Boolean(val.match(regex));
      const msg = valid ? "" : "This field must contain digits only.";
      return { valid: valid, msg: msg };
    },
  },
  numbersOnlyExact: {
    validate: function (val, num) {
      if (val === null) {
        val = "";
      }
      const regexString = `^[0-9]{${num}}$`;
      const regex = new RegExp(regexString);
      const valid = Boolean(val.match(regex));
      const msg = valid ? "" : `This field must contain exactly ${num} digits.`;
      return { valid: valid, msg: msg };
    },
  },
  numbersOnlyBetween: {
    validate: function (val, min, max) {
      if (val === null) {
        val = "";
      }
      const regexString = `^[0-9]{${min},${max}}$`;
      const regex = new RegExp(regexString);
      const valid = Boolean(val.match(regex));
      const msg = valid ? "" : `This field must contain between ${min} to ${max} digits.`;
      return { valid: valid, msg: msg };
    },
  },
  numbersAndLettersMin: {
    validate: function (val, min) {
      if (val === null) {
        val = "";
      }
      const regexString = `^[a-zA-Z0-9]{${min},}$`;
      const regex = new RegExp(regexString);
      const valid = Boolean(val.match(regex));
      const msg = valid ? "" : `This field must contain a minimum of ${min} numbers and letters.`;
      return { valid: valid, msg: msg };
    },
  },
  numbersAndLettersBetween: {
    validate: function (val, min, max) {
      if (val === null) {
        val = "";
      }
      const regexString = `^[a-zA-Z0-9]{${min},${max}}$`;
      const regex = new RegExp(regexString);
      const valid = Boolean(val.match(regex));
      const msg = valid ? "" : `This field must contain between ${min} and ${max} numbers and letters.`;
      return { valid: valid, msg: msg };
    },
  },
  charactersMin: {
    validate: function (val, min) {
      if (val === null) {
        val = "";
      }
      let valid;
      val.length >= min ? (valid = true) : (valid = false);
      const msg = valid ? "" : `This field must contain at least ${min} characters.`;
      return { valid: valid, msg: msg };
    },
  },
  charactersMax: {
    validate: function (val, max) {
      if (val === null) {
        val = "";
      }
      let valid;
      val.length <= max ? (valid = true) : (valid = false);
      const msg = valid ? "" : `This field must contain at max ${max} characters.`;
      return { valid: valid, msg: msg };
    },
  },
  currency: {
    validate: function (val) {
      if (val === null) {
        val = "";
      }
      const regex = /^[0-9]*\.?[0-9]+$/;
      const valid = Boolean(val.match(regex));
      const msg = valid ? "" : "This must be a valid currency amount.";
      return { valid: valid, msg: msg };
    },
  },
  orderLimitMin: {
    validate: function (val, min) {
      if (val === null) {
        val = "";
      }
      const currency = Number(val);
      const minNumber = Number(min);
      const valid = Boolean(currency >= minNumber);
      const msg = valid ? "" : `Minimum order is $${min}.`;
      return { valid: valid, msg: msg };
    },
  },
  orderLimitMax: {
    validate: function (val, max) {
      if (val === null) {
        val = "";
      }
      const currency = Number(val);
      const maxNumber = Number(max);
      const valid = Boolean(currency <= maxNumber);
      const msg = valid ? "" : `Maximum order is $${max}.`;
      return { valid: valid, msg: msg };
    },
  },
  email: {
    validate: function (val) {
      if (val === null) {
        val = "";
      }
      const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      const valid = Boolean(val.match(regex));
      const msg = valid ? "" : "Invalid email.";
      return { valid: valid, msg: msg };
    },
  },
  password: {
    validate: function (val) {
      if (val === null) {
        val = "";
      }
      // const regex = /^(?! )(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{7,}[^\s]+$/;
      const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;
      const valid = Boolean(val.match(regex));
      const msg = valid ? "" : "Password must be a minimum 8 characters and include numbers, captial and lowercase letters.";
      return { valid: valid, msg: msg };
    },
  },
};

export const validateValue = function (val, rulesArray) {
  let isInputValid = false;
  let errormsgsArray = [];
  for (const item of rulesArray) {
    let validationResult;
    if ("customOverrideRule" in item) validationResult = item.customOverrideRule();
    else validationResult = item.validateRule(val, validationRules[item.name]);
    if (!validationResult.valid) errormsgsArray.push(validationResult.msg);
  }
  if (errormsgsArray.length === 0) isInputValid = true;
  return {
    valid: isInputValid,
    errormsgs: errormsgsArray,
  };
};

export const validateValues = function (valAndRulesArray) {
  for (const item of valAndRulesArray) {
    let val = item.value;
    let rules = item.rules;
    if (rules) {
      let result = validateValue(val, rules);
      if (result.errormsgs.length > 0) return false;
    }
  }
  return true;
};

export const _get = function (obj, path) {
  let splits = path.split(".");
  for (let index = 0; index < splits.length; index++) {
    const item = splits[index];
    if (index === splits.length - 1) return obj[item];
    else obj = obj[item];
  }
  return undefined;
};

export const _set = function (obj, path, val) {
  let splits = path.split(".");
  for (let index = 0; index < splits.length; index++) {
    const item = splits[index];
    if (index === splits.length - 1) obj[item] = val;
    else obj = obj[item];
  }
};
